export enum EVENT_NAME {
  CLOSE_CLOUD_KIT = 'closeCloudKit',
}

export type EventCallBack<T> = (props: T) => void;

export enum BindType {
  common = 'common',
  once = 'once',
}

export interface EventData<T> {
  eventName: EVENT_NAME.CLOSE_CLOUD_KIT;
  bindType: BindType;
  callback: (args: T) => void;
}
